import mutations from "@/store/mutations/userStatusMutation";
import actions from "../actions/userStatusAction";
import getters from "@/store/getters/userStatusGetter";
/**
 * [ALL] ALL user status
 */
export default {
  state: {
    userStatusList: []
  },
  mutations,
  actions,
  getters
};
